__turbopack_context__.v({
  "active": "style-module-scss-module__9QBnuG__active",
  "component": "style-module-scss-module__9QBnuG__component",
  "exptabs": "style-module-scss-module__9QBnuG__exptabs",
  "tabs": "style-module-scss-module__9QBnuG__tabs",
});
